<template>
  <div>
    <div class="page-header"><h2>SME Funding</h2></div>
    <section class="page-content">
      <p>
        We understand the importance of funding to entrepreneurs as well as
        mentorship. Hence we are poised to unlock the many challenges
        entrepreneurs face in getting funds in order to see to their successes.
      </p>
      <p>
        We help entrepreneurs access funding via grants, incubation and
        accelerator programs, venture capital, equity investment and loans from
        organizations such as BOI.
      </p>
      <p>Fill the form below to get started:</p>
    </section>
    <!-- use map array modifier to select only titles -->
    <ServiceForm :options-list="['SME Funding']" id="form"></ServiceForm>
  </div>
</template>

<script>
import ServiceForm from "./ServiceForm.vue";
export default {
  components: {
    ServiceForm
  }
};
</script>
